import React, {FunctionComponent, useState} from 'react';
import useWindowSize from '@/utils/responsive/hooks/useWindowSize.js';
import {BREAKPOINT_DESKTOP} from '@/utils/constants';

const MOBILE_DESCRIPTION_LENGTH = 108;
const DESKTOP_DESCRIPTION_LENGTH = 177;

interface Props {
    description: string;
}

export const Description: FunctionComponent<Props> = ({description}) => {
    const [isLongDescription, setLongDescription] = useState(false);
    if (!description) {
        return null;
    }
    const isMobile = useWindowSize().width <= BREAKPOINT_DESKTOP;
    const getShotDescription = () => {
        return isMobile
            ? description.substring(0, MOBILE_DESCRIPTION_LENGTH)
            : description.substring(0, DESKTOP_DESCRIPTION_LENGTH);
    };
    if (isLongDescription) {
        return <p>{description}</p>;
    }
    return (
        <>
            <p>{`${getShotDescription()} ... `}</p>
            <p onClick={() => setLongDescription(true)} className='show-more'>
                En savoir +
            </p>
        </>
    );
};
